import React from 'react'

import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { slugify } from '../utils'

import * as Curves from './visuals/curves'

const Wrap = styled.div`
  ${props => props.inline && `
    display: inline-block;
    width: 50%;
    margin: 1.5rem;
  `}

  width: 280px;
  height: 280px;

  background: url(${props => props.background});
  user-select: none;

  position: relative;
`

const CurveWrap = styled.div`
  position: absolute;
  bottom: -3px;
`

const Text = styled.p`
  margin: 0;

  font-family: 'Source Sans Pro';
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.25rem;
  color: #fff;
  text-align: left;

  position: absolute;
  left: 1.5rem;
  bottom: 1rem;

  /* To make the text wrap */
  width: 50%;
`

const TestamentBlock = (props) => {

  const Curve = Curves[props.curve]

  return (
    <Link to={`${process.env.REACT_APP_APP_HOIST}/${slugify(props.children)}`}>
      <Wrap {...props}>
        <CurveWrap><Curve width={280} /></CurveWrap>
        <Text>{props.children}</Text>
      </Wrap>
    </Link>
  )

}

export default TestamentBlock



// WEBPACK FOOTER //
// ./src/components/TestamentBlock.js